import {IssueOpenedIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {TrackedByItems$key} from './__generated__/TrackedByItems.graphql'
import type {TrackedByItems_item$key} from './__generated__/TrackedByItems_item.graphql'

type TrackedByProps = {
  issue: TrackedByItems$key
  onLinkClick?: (event: MouseEvent) => void
}

export function TrackedBy({issue, onLinkClick}: TrackedByProps) {
  const {trackedInIssues} = useFragment(
    graphql`
      fragment TrackedByItems on Issue {
        trackedInIssues(first: 10) {
          nodes {
            ...TrackedByItems_item
          }
        }
      }
    `,
    issue,
  )
  // filter out nulls
  const items = (trackedInIssues?.nodes || []).flatMap(a => (a ? a : []))
  return (
    <>
      {items.map((item, index) => {
        return <TrackedItem key={index} item={item} onLinkClick={onLinkClick} />
      })}
    </>
  )
}

type TrackedItemProps = {
  item: TrackedByItems_item$key
  onLinkClick?: (event: MouseEvent) => void
}

function TrackedItem({item, onLinkClick}: TrackedItemProps) {
  const {
    url,
    number,
    title,
    repository: {nameWithOwner},
  } = useFragment(
    graphql`
      fragment TrackedByItems_item on Issue {
        url
        number
        title
        repository {
          nameWithOwner
        }
      }
    `,
    item,
  )

  return (
    <ActionList.LinkItem
      href={url}
      target="_blank"
      onClick={
        onLinkClick
          ? (event: React.MouseEvent<HTMLElement>) => {
              onLinkClick(event.nativeEvent)
            }
          : undefined
      }
    >
      <ActionList.LeadingVisual>
        <IssueOpenedIcon />
      </ActionList.LeadingVisual>
      {title}
      <ActionList.Description variant="block">
        {nameWithOwner}#{number}
      </ActionList.Description>
    </ActionList.LinkItem>
  )
}

try{ TrackedBy.displayName ||= 'TrackedBy' } catch {}
try{ TrackedItem.displayName ||= 'TrackedItem' } catch {}